import styled from "styled-components";

/**
 * AuthContainer は削除済み。認証ページのカードは
 * `<Modal variant="auth">` を使用すること。
 *
 * AuthErrorMessage はエラー文の標準スタイルとしてここに残す。
 */
export const AuthErrorMessage = styled.div.attrs({
  className: "bodytext-13",
})`
  color: var(--soremo-green);
  padding: 8px 12px;
  background-color: var(--soremo-bg-white);
  border: 1px solid var(--soremo-green);
  border-radius: 4px;
`;
